// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"6f68124f","457":"b370354b","695":"5a48ccf6","961":"94f1e1fc"}[chunkId] + ".chunk.js";
};